export default function addCaseStudiesHandlers() {
  const rowsDisplayedProperty = "--case-studies__rows-displayed";
  const componentSelector = ".case-studies";
  const wrapperSelector = ".case-studies__grid-wrapper";
  const viewMoreSelector = ".case-studies__view-more";
  const viewLessSelector = ".case-studies__view-less";
  const filterSelector = ".case-studies__topic-filter";
  const selectedFilterClass = "tabs__tab--selected";
  const selectedFilterSelector = "." + selectedFilterClass;
  const cardSelector = ".case-study__card";
  const hiddenCardClass = "case-study__card--hidden";
  const hiddenCardSelector = "." + hiddenCardClass;
  const visibleCardSelector = cardSelector + ":not(" + hiddenCardSelector + ")";
  const viewLessRowThreshold = 2;

  const isResponsiveView = () =>
    !window.matchMedia("(min-width: 1140px)").matches; // hack for $bp-x-large, see \frontend\EGH\scss\_breakpoints.scss

  const getNumCardsPerRow = () => (isResponsiveView() ? 1.0 : 3.0);

  const getAllCards = (component) => component.querySelectorAll(cardSelector);

  const getFilteredCards = ($component, topic) => {
    topic =
      topic ||
      $component.find(selectedFilterSelector).text().replaceAll(" ", "-");

    if (topic) {
      return $(cardSelector + "[data-" + topic + "]");
    } else {
      return $(cardSelector);
    }
  };

  const getVisibleCards = (component) =>
    component.querySelectorAll(visibleCardSelector);

  const getNumVisibleCards = (component) => getVisibleCards(component).length;

  const getCurNumRows = (component) => {
    const numVisibleCards = getNumVisibleCards(component);
    const numCardsPerRow = getNumCardsPerRow();

    return Math.ceil(numVisibleCards / numCardsPerRow);
  };

  const getMaxRows = (component, cards) => {
    // Return the max number of rows - for a set of cards (if specified), else for all cards
    const numAllCards = (cards || getAllCards(component)).length;
    const numCardsPerRow = getNumCardsPerRow();

    return Math.ceil(numAllCards / numCardsPerRow);
  };

  const setDisplayedRows = (wrapper, newNumRows) =>
    wrapper.style.setProperty(rowsDisplayedProperty, newNumRows);

  const viewMoreClickHandler = (event) => {
    const $button = $(event.target);

    const $component = $button.parents(componentSelector).first();
    const component = $component[0];
    const wrapper = $button.siblings(wrapperSelector)[0];

    const isFilterApplied =
      component.querySelectorAll(selectedFilterSelector).length > 0;

    const maxRows = isFilterApplied
      ? getMaxRows(component, getFilteredCards($component))
      : getMaxRows(component);

    const numRows = getCurNumRows(component);
    const newNumRows = numRows + 1;

    if (numRows < maxRows) {
      setDisplayedRows(wrapper, newNumRows);

      getFilteredCards($component)
        .slice(0, getNumCardsPerRow() * newNumRows)
        .removeClass(hiddenCardClass);
    }

    if (newNumRows >= maxRows) {
      $button.hide(0);
      $button.next(viewLessSelector).show(0);
    }
  };

  const viewLessClickHandler = (event) => {
    const $button = $(event.target);
    const wrapper = $button.siblings(wrapperSelector)[0];
    const $component = $button.parents(componentSelector).first();
    const component = $component[0];
    const numRows = getCurNumRows(component);
    const newNumRows = numRows - 1;

    const showViewMoreButton = () => {
      $button.hide(0);
      $button.siblings(viewMoreSelector).show(0);
    };

    if (numRows > 1) {
      setDisplayedRows(wrapper, newNumRows);

      const $filteredCards = getFilteredCards($component);
      $filteredCards
        .slice(getNumCardsPerRow() * newNumRows, $filteredCards.length)
        .removeClass(hiddenCardClass)
        .addClass(hiddenCardClass);

      if (newNumRows <= viewLessRowThreshold) {
        showViewMoreButton();
      }
    } else {
      showViewMoreButton();
    }
  };

  const topicFilterClickHandler = (event) => {
    const $button = $(event.target);
    const $component = $button.parents(componentSelector).first();
    const component = $component[0];
    const topic = $button.text().replaceAll(" ", "-");
    const $filteredCards = getFilteredCards(component, topic);

    const isApplyingFilter = !$button.hasClass(selectedFilterClass);

    const wrapper = component.querySelector(wrapperSelector);

    // clear all filters
    $(filterSelector).removeClass(selectedFilterClass);

    // hide all cards
    const $cards = $component.find(cardSelector);
    $cards
      .removeClass(hiddenCardClass) // ensure it's only set once
      .addClass(hiddenCardClass);

    if (isApplyingFilter) {
      // apply filter
      $button.addClass(selectedFilterClass);

      // show only the relevant cards
      // use class instead of hide so we can better determine how many cards are visible
      $filteredCards.removeClass(hiddenCardClass);
    } else {
      // show all cards
      $component.find(cardSelector).removeClass(hiddenCardClass);
    }
    const curNumRows = getCurNumRows(component);
    const newNumRows = isApplyingFilter ? curNumRows : viewLessRowThreshold;

    if (isApplyingFilter) {
      // fix for case where switching from one filter to another causes the View More button to be hidden due to card visibility
      setDisplayedRows(wrapper, viewLessRowThreshold);
    }
    const newMaxNumRows = getMaxRows(
      component,
      component.querySelectorAll(visibleCardSelector),
    );

    setDisplayedRows(wrapper, newNumRows);

    if (!isApplyingFilter) {
      // hide cards if needed
      $cards.slice(newNumRows * getNumCardsPerRow()).addClass(hiddenCardClass);
    }

    if (curNumRows < newMaxNumRows || !isApplyingFilter) {
      $(viewMoreSelector).show(0);
      $(viewLessSelector).hide(0);
    } else {
      $(viewMoreSelector).hide(0);

      if (curNumRows > viewLessRowThreshold) {
        $(viewLessSelector).show(0);
      } else {
        $(viewLessSelector).hide(0);
      }
    }
  };

  (function initialize() {
    const numInitiallyDisplayedCards =
      viewLessRowThreshold * getNumCardsPerRow();

    // Mark cards as hidden
    $(cardSelector).slice(numInitiallyDisplayedCards).addClass(hiddenCardClass);

    $(viewMoreSelector)
      .off("click", viewMoreClickHandler)
      .on("click", viewMoreClickHandler);

    $(viewLessSelector)
      .off("click", viewLessClickHandler)
      .on("click", viewLessClickHandler);

    $(filterSelector)
      .off("click", topicFilterClickHandler)
      .on("click", topicFilterClickHandler);
  })();
}
